import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom:'var(--regxlgap)',
    paddingRight: 'var(--reggap)',
    paddingLeft: 'var(--reggap)',
    width: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    '&:before, &:after': {
      content: '""',
      flex: '1 1',
      borderBottom: '1px solid var(--clr_pastbluegrey)',
      margin: 'auto',
    },
    '&:before': {
      marginRight: '10px'
    },
    '&:after': {
      marginLeft: '10px'
    }
  },
  contentWrapper: {
    display: 'inline-flex',
    flexFlow: 'column wrap',
    alignItems: 'center',
  },
  title: {
  },
  amount: {
    fontWeight: 'bold',
  }
}));

export default useStyles;
